var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBehance(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 215 215",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#0057ff;}.cls-2{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Behance"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Background",
    className: "cls-1",
    cx: 107.5,
    cy: 107.5,
    r: 107.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Behance-2",
    "data-name": "Behance"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Behance-3",
    "data-name": "Behance",
    className: "cls-2",
    d: "M1193.4,900a38.87,38.87,0,0,1,9.38,1,20.93,20.93,0,0,1,7.25,3.1,14.28,14.28,0,0,1,4.66,5.75,21.73,21.73,0,0,1,1.66,8.9,17.12,17.12,0,0,1-2.46,9.54,18.12,18.12,0,0,1-7.32,6.26,17.43,17.43,0,0,1,9.86,7,21.75,21.75,0,0,1,3.27,12.13,22.51,22.51,0,0,1-2.07,9.89,19.19,19.19,0,0,1-5.65,6.87,24.78,24.78,0,0,1-8.19,3.92,35,35,0,0,1-9.38,1.27h-34.8V900Zm-2,30.56a10.93,10.93,0,0,0,6.92-2.1,8.21,8.21,0,0,0,2.73-6.87,9.28,9.28,0,0,0-.87-4.34,6.26,6.26,0,0,0-2.41-2.59,9.1,9.1,0,0,0-3.45-1.34,20.5,20.5,0,0,0-4.06-.35h-14.87v17.66h16Zm.87,32.18a18.45,18.45,0,0,0,4.45-.48,10.6,10.6,0,0,0,3.73-1.61,8,8,0,0,0,2.6-3,10.74,10.74,0,0,0,.93-4.9,10.1,10.1,0,0,0-3.13-8.34,12.65,12.65,0,0,0-8.25-2.46h-17.21v20.81Z",
    transform: "translate(-1108 -831)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Behance-4",
    "data-name": "Behance",
    className: "cls-2",
    d: "M1242.15,962.45a12.46,12.46,0,0,0,9.25,3.3,12.28,12.28,0,0,0,7.45-2.31,9.56,9.56,0,0,0,3.79-4.82h12.57a24.75,24.75,0,0,1-9.25,14.09,25.7,25.7,0,0,1-15,4.28,28.37,28.37,0,0,1-11.11-2.11,23.71,23.71,0,0,1-8.38-5.89,27.31,27.31,0,0,1-5.25-9.11,34.41,34.41,0,0,1-1.87-11.64,33.72,33.72,0,0,1,1.93-11.43A25.78,25.78,0,0,1,1251,919.28a23.68,23.68,0,0,1,11.55,2.74,24.25,24.25,0,0,1,8.12,7.22,30.24,30.24,0,0,1,4.59,10.38,40.67,40.67,0,0,1,1,12.2H1238.8A14.91,14.91,0,0,0,1242.15,962.45Zm16.43-28.74a10.4,10.4,0,0,0-8-3,11.32,11.32,0,0,0-5.65,1.27,12.09,12.09,0,0,0-3.59,3,11.62,11.62,0,0,0-1.93,3.85,16,16,0,0,0-.66,3.58h23.19a15.75,15.75,0,0,0-3.3-8.69Z",
    transform: "translate(-1108 -831)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Behance-5",
    "data-name": "Behance",
    className: "cls-2",
    x: 127.71,
    y: 74.03,
    width: 29.07,
    height: 7.43
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBehance);
export default __webpack_public_path__ + "static/media/Behance.99549dc3d61d2e1f2825cbd23050be77.svg";
export { ForwardRef as ReactComponent };